export default "__VITE_ASSET__CLvnEnGe__"